import { render, staticRenderFns } from "./TaskToDo.vue?vue&type=template&id=d5500d9a&scoped=true"
import script from "./TaskToDo.vue?vue&type=script&lang=js"
export * from "./TaskToDo.vue?vue&type=script&lang=js"
import style0 from "./TaskToDo.vue?vue&type=style&index=0&id=d5500d9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5500d9a",
  null
  
)

export default component.exports